import React, {useEffect, useState} from 'react';
import {SponsorshipTier} from "types/SponsorshipTier";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";
import {useOperator} from "context/OperatorContext";

type Props = {
    sponsorshipTier: SponsorshipTier | null
    show: boolean
    onDelete?: (sponsorshipTier: SponsorshipTier) => any
    onDeleteFail?: (sponsorshipTier: SponsorshipTier, error: unknown) => any
    onCancel?: () => any
}

function DeleteSponsorshipTier(props: Props) {
    const {sponsorshipTier, show, onDelete, onDeleteFail, onCancel} = props

    const {termFor} = useOperator()
    const {notify} = useNotifications()

    const [name, setName] = useState<string>(sponsorshipTier?.name || `this ${termFor('sponsorship')} tier`);
    const {mutateAsync: deleteSponsorshipTier} = useMutation(ngage.sponsorshipTiers.destroy)

    useEffect(() => {
        if(sponsorshipTier) setName(sponsorshipTier.name)
    }, [sponsorshipTier]);

    async function handleDeleteSponsorshipTier() {
        if (sponsorshipTier) {
            try {
                await deleteSponsorshipTier(sponsorshipTier.id)
                await invalidate('sponsorship-tiers.all')

                notify("success", `${termFor('Sponsorship')} Tier Deleted`, `${sponsorshipTier.name} has been permanently removed`)
                if (onDelete) onDelete(sponsorshipTier)
            } catch (error) {
                notify("error", `${termFor('Sponsorship')} Tier Not Deleted`, `${sponsorshipTier.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(sponsorshipTier, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title={`Delete ${termFor('Sponsorship')} Tier`}
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteSponsorshipTier}
            onCancel={handleCancel}
        />
    );
}

export default DeleteSponsorshipTier;